import { useState } from "react";
import { HelpCircle, ChevronDown } from "lucide-react";

// Anlaşılması zor teknik kavramlar için sade Türkçe açıklama kutusu (örnekli).
// Varsayılan kapalı; kullanıcı "Bu ne demek?" başlığına tıklayınca açılır.
export function InfoBox({ title = "Bu ne demek?", children, example, testid, defaultOpen = false, tone = "sky" }) {
  const [open, setOpen] = useState(defaultOpen);
  const tones = {
    sky: "bg-sky-50 ring-sky-200 text-sky-800",
    emerald: "bg-emerald-50 ring-emerald-200 text-emerald-800",
    amber: "bg-amber-50 ring-amber-200 text-amber-800",
  };
  return (
    <div data-testid={testid} className={`rounded-lg ring-1 ring-inset ${tones[tone] || tones.sky}`}>
      <button type="button" onClick={() => setOpen((o) => !o)}
        data-testid={testid ? `${testid}-toggle` : undefined}
        className="flex w-full items-center gap-2 px-3 py-2 text-left">
        <HelpCircle className="h-4 w-4 shrink-0 opacity-80" />
        <span className="flex-1 text-xs font-bold">{title}</span>
        <ChevronDown className={`h-4 w-4 opacity-60 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="space-y-1.5 border-t border-white/60 px-3 py-2.5 text-[12px] leading-relaxed text-slate-700">
          <div>{children}</div>
          {example && (
            <div className="rounded-md bg-white/80 px-2.5 py-1.5 text-[11px]">
              <span className="font-bold text-slate-800">Örnek: </span>{example}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default InfoBox;
